import { DocumentPackageType, ServiceName } from '@consigli/types';

export enum Route {
  ROOT = '/',
  PROJECTS = 'projects',
  SERVICES = 'services',
  AGENTS = 'agents',
  USERS = 'users',
  PACKAGES = 'packages',
  DASHBOARD = 'dashboard',
  UPLOAD = 'upload',
  SEARCH = 'search',
  FINDINGS = 'findings',
  DOCUMENTS = 'documents',
  CATEGORIZATION = 'categorization',
  DUE_DILIGENCE = 'due-diligence',
  TENANT_REQUIREMENTS = 'tenant-requirements',
  TENDER_DOCUMENTS = 'tender-documents',
  MANAGEMENT_OPERATIONS_MAINTENANCE = 'management-operations-maintenance',
  TENANT_SPECIFICATION = 'tenant-specification',
  OFFER = 'offer',
  BID_REVIEW = 'bid-review',
  CEILING_GRID = 'ceiling-grid',
  CEILING_PLAN = 'ceiling-plan',
  FLOOR_PLAN = 'floor-plan',
  PLANT_ROOM = 'plant-room',
  SPACE_ANALYSIS = 'space-analysis',
  PARKING = 'parking',
  REPORTS = 'reports',
  REPORT_GENERATION = 'report-generation',
  SOLUTION_VIEWER = 'solution-viewer',
  STRUCTURAL = 'structural',
  NEW_PROJECT = 'new-project',
  RESULTS = 'results',
  INPUT = 'input',
  CREATE = 'create',
  INVITE_USER = 'invite-user',
  USER_MANAGEMENT = 'user-management',
  STEEL_FRAMES = 'steel-frames',
  CONCRETE_COLUMNS = 'concrete-columns',
  LOAD_CALCULATION = 'load-calculation',
  MEETING_SECRETARY = 'meeting-secretary',
  SCHEDULE_CHECK = 'schedule-check',
  CONTRACT_REVIEW = 'contract-review',
  RFP_RFQ_REVIEW = 'rfp-rfq-review',
  DESIGN_PACKAGE_REVIEW = 'design-package-review',
  MEETINGS = 'meetings',
  CALENDAR = 'calendar',
  TEMPLATES = 'templates',
  SETTINGS = 'settings',
  ACTION_ITEMS = 'action-items',
  PROCESSING_SPEC_REQUIREMENTS = 'processing-spec-requirements',
  USER_REVIEW_SPEC_REQUIREMENTS = 'user-review-spec-requirements',
  PROCESSING_LOAD_CALCULATION = 'processing-load-calculation',
  BUILDING_LEVEL_OVERVIEW = 'building-level-overview',
  TUTORIALS = 'tutorials',
  COMPARISON = 'comparison',
  SITE_DUE_DILIGENCE = 'site-due-diligence',
  LOCATION = 'location',
  LUMINAIRE_SCHEDULE = 'luminaire-schedule',
  SUMMARY = 'summary',
  QA_AGENT = 'qa-agent',
  CODE_RESEARCH_AGENT = 'code-research-agent',
  VERSION_COMPARE = 'version-compare',
  WATER_PROCESS_SYSTEMS_AGENT = 'water-process-systems-agent',
  BID_COMPARISON = 'bid-comparison',
}

export const ServiceIdIndexValue: Partial<Record<ServiceName, DocumentPackageType>> = {
  [ServiceName.DUE_DILIGENCE]: DocumentPackageType.DUE_DILIGENCE,
  [ServiceName.TENANT_REQUIREMENTS]: DocumentPackageType.TENANT_REQUIREMENTS,
  [ServiceName.MANAGEMENT_OPERATIONS_MAINTENANCE]:
    DocumentPackageType.MANAGEMENT_OPERATIONS_MAINTENANCE,
  [ServiceName.TENDER_DOCUMENTS]: DocumentPackageType.TENDER_DOCUMENTS,
  [ServiceName.OFFER]: DocumentPackageType.OFFER,
  [ServiceName.BID_REVIEW]: DocumentPackageType.OFFER,
  [ServiceName.TENANT_SPECIFICATION]: DocumentPackageType.TENANT_SPECIFICATION,
  [ServiceName.SCHEDULE_CHECK]: DocumentPackageType.SCHEDULE_CHECK,
  [ServiceName.SITE_DUE_DILIGENCE]: DocumentPackageType.SITE_DUE_DILIGENCE,
  [ServiceName.CONTRACT_REVIEW]: DocumentPackageType.CONTRACT_REVIEW,
  [ServiceName.REPORT_GENERATION]: DocumentPackageType.REPORT_GENERATION,
  [ServiceName.LUMINAIRE_SCHEDULE]: DocumentPackageType.LUMINAIRE_SCHEDULE,
  [ServiceName.RFP_RFQ_REVIEW]: DocumentPackageType.RFP_RFQ_REVIEW,
  [ServiceName.DESIGN_PACKAGE_REVIEW]: DocumentPackageType.DESIGN_PACKAGE_REVIEW,
  [ServiceName.VERSION_COMPARE]: DocumentPackageType.VERSION_COMPARE,
  [ServiceName.WATER_PROCESS_SYSTEMS_AGENT]: DocumentPackageType.WATER_PROCESS_SYSTEMS_AGENT,
};

export const ServiceIdNameIndex: Partial<Record<DocumentPackageType, ServiceName>> = {
  [DocumentPackageType.DUE_DILIGENCE]: ServiceName.DUE_DILIGENCE,
  [DocumentPackageType.TENANT_REQUIREMENTS]: ServiceName.TENANT_REQUIREMENTS,
  [DocumentPackageType.MANAGEMENT_OPERATIONS_MAINTENANCE]:
    ServiceName.MANAGEMENT_OPERATIONS_MAINTENANCE,
  [DocumentPackageType.TENDER_DOCUMENTS]: ServiceName.TENDER_DOCUMENTS,
  [DocumentPackageType.OFFER]: ServiceName.OFFER,
  [DocumentPackageType.TENANT_SPECIFICATION]: ServiceName.TENANT_SPECIFICATION,
  [DocumentPackageType.SCHEDULE_CHECK]: ServiceName.SCHEDULE_CHECK,
  [DocumentPackageType.SITE_DUE_DILIGENCE]: ServiceName.SITE_DUE_DILIGENCE,
  [DocumentPackageType.CONTRACT_REVIEW]: ServiceName.CONTRACT_REVIEW,
  [DocumentPackageType.REPORT_GENERATION]: ServiceName.REPORT_GENERATION,
  [DocumentPackageType.LUMINAIRE_SCHEDULE]: ServiceName.LUMINAIRE_SCHEDULE,
  [DocumentPackageType.RFP_RFQ_REVIEW]: ServiceName.RFP_RFQ_REVIEW,
  [DocumentPackageType.DESIGN_PACKAGE_REVIEW]: ServiceName.DESIGN_PACKAGE_REVIEW,
  [DocumentPackageType.VERSION_COMPARE]: ServiceName.VERSION_COMPARE,
  [DocumentPackageType.WATER_PROCESS_SYSTEMS_AGENT]: ServiceName.WATER_PROCESS_SYSTEMS_AGENT,
};

export const DashboardRoutes = {
  [ServiceName.TENDER_DOCUMENTS]: 'tender-documents',
  [ServiceName.OFFER]: 'offer',
  [ServiceName.BID_REVIEW]: 'bid-review',
  [ServiceName.TENANT_REQUIREMENTS]: 'tenant-requirements',
  [ServiceName.TENANT_SPECIFICATION]: 'tenant-specification',
  [ServiceName.DUE_DILIGENCE]: 'due-diligence',
  [ServiceName.MANAGEMENT_OPERATIONS_MAINTENANCE]: 'management-operations-maintenance',
  [ServiceName.FLOOR_PLAN]: 'floor-plan',
  [ServiceName.CEILING_GRID]: 'ceiling-grid',
  [ServiceName.CEILING_PLAN]: 'ceiling-plan',
  [ServiceName.PLANT_ROOM]: 'plant-room',
  [ServiceName.SPACE_ANALYSIS]: 'space-analysis',
  [ServiceName.REPORT_GENERATION]: 'report-generation',
  [ServiceName.STRUCTURAL]: 'structural',
  [ServiceName.LOAD_CALCULATION]: 'load-calculation',
  [ServiceName.MEETING_SECRETARY]: 'meeting-secretary',
  [ServiceName.SCHEDULE_CHECK]: 'schedule-check',
  [ServiceName.SITE_DUE_DILIGENCE]: 'site-due-diligence',
  [ServiceName.CONTRACT_REVIEW]: 'contract-review',
  [ServiceName.LUMINAIRE_SCHEDULE]: 'luminaire-schedule',
  [ServiceName.RFP_RFQ_REVIEW]: 'rfp-rfq-review',
  [ServiceName.DESIGN_PACKAGE_REVIEW]: 'design-package-review',
  [ServiceName.VERSION_COMPARE]: 'version-compare',
  [ServiceName.WATER_PROCESS_SYSTEMS_AGENT]: 'water-process-systems-agent',
};
